export default "/rider_logo.8e780176-8a4ef7.svg?svgr";